import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from './api';

export const fetchTrackingLinks = createAsyncThunk(
  'trackingLinks/fetch',
  async (eventId: string) => {
    return await api.fetchTrackingLinksApi(eventId);
  },
);

export const createTrackingLink = createAsyncThunk(
  'trackingLinks/create',
  async (data: { eventId: string; name: string; url: string }) => {
    const result = await api.createTrackingLinkApi(data);
    // Refetch to get updated stats
    const allLinks = await api.fetchTrackingLinksApi(data.eventId);
    return allLinks;
  },
);

export const deleteTrackingLink = createAsyncThunk(
  'trackingLinks/delete',
  async (data: { eventId: string; linkId: string }) => {
    await api.deleteTrackingLinkApi(data);
    // Refetch to get updated list
    const allLinks = await api.fetchTrackingLinksApi(data.eventId);
    return allLinks;
  },
);
